import React, { FC, PropsWithChildren } from "react";

interface SectionContainerDarkProps {
    additionalClassName?: string;
    id: string;
    backgroundImageUrl?: string;
}

export const SectionContainerDark: FC<PropsWithChildren<SectionContainerDarkProps>> = ({ children, id, additionalClassName, backgroundImageUrl }) => {
    const hasBackgroundImage = !!backgroundImageUrl;

    return (
        <section
            id={id}
            className={`relative py-20 ${!hasBackgroundImage ? 'bg-secondary-100' : ''} ${additionalClassName ?? ""}`}
        >
            {hasBackgroundImage && (
                <>
                    {/* Background Image */}
                    <div
                        className="absolute inset-0 bg-cover bg-center z-0"
                        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
                    />
                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-secondary-100 opacity-80 z-10" />
                </>
            )}

            {/* Content */}
            <div className={`relative ${hasBackgroundImage ? 'z-20' : ''}`}>
                {children}
            </div>
        </section>
    )
}
